
const Stat = require('public/stat');
// const Pullup = require('@ali/aliplay-pullup');
const _ = require('lodash');
const AgStat = require('public/ag_statv2');
const _newsTemplateType = $('#_newsTemplateType').val() || '';
const _keywordsType = $('#_keywordsType').val() || '';
const _gameId = $('#_gameId').val();
const _curinfoid = $('#currentinfoid').val() || '';
const _title = $('#_title').val() || '';
const _categoryName = $('#_categoryName').val() || '';
const _collectionIds = $('#_collectionIds').val() || '';
const _zzjs = $('#authorRole').val() || '';
const _zxbj = $('#_zxbj').val() || '';
const _submit_remark = $('#_submit_remark').val() || '';
const _audit_person = $('#_audit_person').val() || '';
const _editor = $('#_editor').val() || '';
class Advert {
  constructor() {
    this.data;// 原数据的data.adps[n] 即广告位节点
    this.ex; // data.adps[n].adms[0].ex
    this.admData;// data.adps[n].adms[0] 即物料节点
    this.GD_params;// 向发行请求的jsonp的请求参数
    this.DOM; // 本广告位的$DOM
    this.AsyncDOM;// 请求门户后端并获得游戏基础信息后，拼装this.DOM并返回的Promise
    // 避免重复定义打点信息
    if (window.GLOBAL_AgStat && window.GLOBAL_AgStat.page) {
      this.ag_stat = window.GLOBAL_AgStat;
    } else {
      const statConfig = {
        ag_field: 'articleid',
        ag_value: _curinfoid,
        ag_a6: _gameId > 0 ? _gameId : '',
        ag_a10: _newsTemplateType,
        ag_a11: _keywordsType,
        ag_a12: _title,
        ag_a13: _categoryName,
        ag_a14: _collectionIds,
        zzjs: _zzjs,
        zxbj: _zxbj,
        submit_remark: _submit_remark,
        audit_person: _audit_person,
        editor: _editor,
      };
      this.ag_stat = new AgStat('article', statConfig);
    }
  }
  get ThirdLevel() {
    return this.IsInPc() ? 'www' : 'a';
  }
  renderXlyx() {
    if (this.IsInPc) return '';
    return `<div class="xlyx_template" data-scenario-id="590ac8a8352f0e7f44f98b06" style="display: none;">
    <div class="game-recommend planA" data-from-down-id="@fromDownId@">
      <div class="game-recommend-main">
        <div class="game-recommend-title">
          下载<span class="game-info">@gamename@</span>的人还会下载
        </div>
        @for=3@
        <div class="game-list-item count-list-item" data-slot-id="@slotId@" pathname="xyqxw_xlyx" data-game-id="@itemId@" data-an="{'page':'homepage','column':'xyqxw'}" type="btn" href="@zoneUrl@" data-statis="text:txt_hotword_xlyx-list_po-@idx@_game-@itemId@">
          <span href="@zoneUrl@" type="btn" class="count-click" pathname="xyqxw_xlyx" data-statis="text:btn_hotword_xlyx-list_po-@idx@_game-@itemId@"><img class="game-img" @src@="@imgUrl@"></span>
          <div class="game-main count-click" type="btn" pathname="xyqxw_xlyx" href="@zoneUrl@" data-statis="text:btn_hotword_xlyx-list_po-@idx@_game-@itemId@">
            <div class="game-name">@name@</div>
            <span class="game-type">@category@</span>
            <span class="game-size">@size@</span>
            <div class="game-desc">@instruction@</div>
          </div>
          <div class="game-download count-download" pathname="xyqxw_xlyx" type="btn" data-us="0" data-gs="@gs@" href="@downUrl@?ch=SO_23" data-statis="text:btn_hotword_xlyx-list_po-@idx@_game-@itemId@">下载</div>
        </div>
        @endfor@
      </div>
    </div>
  </div>`;
  }
  // 公共拉起
  pullUp(gameId, pullUpFrom, ch, isDownload) {
    const opt = isDownload ? 'download' : 'reserve';
    const cfg = {
      pageType: 'game_detail', // 需要拉起页面 pageType
      opt, // 拉起动作，可选
      gameId,
      ch,
      checkTime: 200,
      pullUpFrom, // 拉起来源
    };
    if (this.IsBaidu() === 1) {
      window.location = `${NineGameClientPullUp.getSchemeDownloadUrl(cfg)}&passParams=isNonPd%3D1%7CisUgAd%3D0`;
    } else {
      NineGameClientPullUp.wakeup(cfg, function(error, update, result) {
        Stat.StatHightSpeedDownload(gameId);
        if (!error) {
          console.log('拉起成功');
        } else {
          console.log('d ===>', `${result}&passParams=isNonPd%3D1%7CisUgAd%3D0`);
          window.location = `${result}&passParams=isNonPd%3D1%7CisUgAd%3D0`;
        }
      });
    }
  }
  // 获取游戏基础信息
  AjaxGetGameBaseInfo() {
    const gameId = this.admData.gameId;
    const self = this;
    return new Promise(function(resolve, reject) {
      // resolve({
      //   "downUrl": "https://a.9game.cn/game/downs_555377_2.html",
      //   "logo": "http://image.9game.cn/s/9game/g/2021/1/8/199613289_.jpg",
      //   "instruction": "《炉石传说》安卓手机版客户端",
      //   "fileSize": "89.1M",
      //   "gameName": "炉石传说",
      //   "category": "卡牌",
      //   "packageproperty": true,
      //   "typeId": 19,
      //   "androidStatus": "运营",
      //   "iosStatus": "",
      //   "expertScore": "8.5",
      //   "commentTotal": 1783,
      //   "forumId": "13838",
      //   gameZone: 'https://www.9game.cn/lscsmsyxcazb/',
      //   tactic: 'https://www.9game.cn/lscsmsyxcazb/gonglue-0-1/',
      //   forum: 'https://bbs.9game.cn/forum-13838-1.html',
      // });
      $.ajax({
        type: 'GET',
        url: `https://${self.ThirdLevel}.9game.cn/tpl/android_new/common/gameinfo_ajax.html`,
        timeout: 4000,
        data: {
          gameId,
        },
        success(res) {
          // const result = res.replace('<script type="text/javascript" src="/public/js/runtime.js"></script><script type="text/javascript" src="/public/js/chunk/advert/ajax/index.js"></script>', '');
          const _res = JSON.parse(res);
          _res.logo = _res.logo ? _res.logo : 'https://image.9game.cn/s/uae/g/0h/portal/image/lazy2.gif';
          _res.downUrl = _res.downUrl ? `https://a.9game.cn${_res.downUrl}` : '';
          _res.gameZone = _res.gameZone ? `https://www.9game.cn/${_res.gameZone}/` : '';
          _res.tactic = _res.tactic ? `https://www.9game.cn/${_res.gameZone}/gonglue-0-1/` : '';
          _res.forum = _res.forumId ? `https://bbs.9game.cn/forum-${_res.forumId}-1.html` : '';
          resolve(_res);
        },
        error(error) {
          reject(error);
        }
      });
    });
  }
  // 广告位数据
  set Data(json) {
    this.data = json;
    this.GD_params = _.get(this.data, 'GD_params');
    this.admData = _.get(this.data, 'adms[0]');
    if (!json) {
      console.error('[advert.js]:<SET>Data can not set an undefined value');
      return;
    }
    // console.log('advert--->', this.data);
    try {
      this.ex = JSON.parse(_.get(this.admData, 'extension'));
    } catch (error) {
      console.log('[advert.js]extension 字端解析错误', e);
    }

    this.AsyncDOM = new Promise((resolve, reject) => {
      this.AjaxGetGameBaseInfo().then(e => {
        this.gameBaseInfo = e;
        this.SetDOM();
        resolve(this.DOM);
        this.JumpToGameZone(this.DOM);
        this.StatToNgmPortal(this.DOM);
      }).catch(e => { reject(e); });
    });
  }
  // 广告位DOM生成
  SetDOM() {
    // 继承重写
  }
  // 判断是否在PC中
  IsInPc() {
    return !!location.host.match('www.9game.cn');
  }
  IsBaidu() {
    if (window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf('baidu') > -1) {
      return 1;
    } else {
      return 0;
    }
  }
  // 跳转专区
  JumpToGameZone(DOM) {
    DOM.find('.href-to-gamezone').on('click', (e) => {
      window.location = this.gameBaseInfo.gameZone;
      return false;
    });
  }
  // 上报统计到wa ngm-portal
  StatToNgmPortal(DOM) {
    const self = this;
    Stat.Stat({ action: 'page_view', from: 'advert_2' });
    DOM.on('click', function(e) {
      if ($(e.target).hasClass('stat-recsys-app-down')) {
        Stat.Stat({ action: 'page_click', from: 'advert_2', target: 'app_download' });
        return;
      } else if ($(e.target).hasClass('stat-recsys-down')) {
        Stat.Stat({ action: 'page_click', from: 'advert_2', target: 'game_download' });
        return;
      }
      const target = $(e.target).attr('class') || $(e.target).text() || $(e.target).parent().attr('class');
      Stat.Stat({ action: 'page_click', from: 'advert_2', target });
    }, true);
  }
  // 公共统计上报事件注册 因为牵扯到曝光点(需要植入页面后获取位置)，需要在外部dom植入操作后引入。
  SetStateEvent() {
    if (!this.DOM) return;
    const ch = _.get(this.ex, 'qdownCh') || _.get(this.ex, 'downCh') || '';
    const originParams = {
      a1: this.admData.recId || '',
      gid: this.admData.gameId || '',
      admid: this.data.adpId,
      ad_id: this.admData.admId,
      info_id: this.GD_params.odId,
      ngid: this.GD_params.odGameId || '',
      fenlei_id: this.GD_params.odType,
      zzjs: this.GD_params.odSource,
      // ut: this.GD_params.ut,
      dashboardId: this.admData.dashboardAccount,
      ch,
      zxbj: this.GD_params.zxbj || '',
      tflx_id: this.data.adPutType || '',
      a2: 'ag_gd_advert_2',
      a4: this.data.odPlanId
    };

    const exploreParams = { action: 'recsys_show', ac: 'recsys_show' };
    _.assign(exploreParams, originParams);
    Stat.ExplorePortal(this.DOM, exploreParams, 'ad');

    this.DOM.find('.stat-recsys-click').on('click', function(e) {
      const params = { action: 'recsys_click', ac: 'recsys_click' };
      _.assign(params, originParams);
      Stat.StatPortal(params, 'ad');
    });

    this.DOM.find('.stat-recsys-down').on('click', function(e) {
      const params = { action: 'recsys_down', ac: 'recsys_down' };
      _.assign(params, originParams);
      Stat.StatPortal(params, 'ad');
      const paramsClick = {};
      Object.assign(paramsClick, params);
      paramsClick.ac = 'recsys_click';
      paramsClick.action = 'recsys_click';
      Stat.StatPortal(paramsClick, 'ad');
    });
    this.DOM.find('.stat-recsys-app-down').on('click', function(e) {
      const params = { action: 'recsys_app_down', ac: 'recsys_app_down' };
      _.assign(params, originParams);
      Stat.StatPortal(params, 'ad');
      const paramsClick = {};
      Object.assign(paramsClick, params);
      paramsClick.ac = 'recsys_click';
      paramsClick.action = 'recsys_click';
      Stat.StatPortal(paramsClick, 'ad');
    });
  }
  // ag打点里广告位位置信息的映射
  getAGA1(adpId) {
    if (adpId == 1335) {
      return 'top';
    } else if (adpId == 1336) {
      return 'mid';
    } else if (adpId == 1337) {
      return 'bot';
    }
  }
  // 补充agstat打点
  SetAgStatEvent() {
    if (!this.DOM) return;
    // advert-article为信息流广告
    this.ag_stat.addRecommendExplorePortalEleMap($('.advert-article'));
    this.ag_stat.addCustomClick($('.advert-article'));
    this.ag_stat.addRecommendExplorePortalEleMap($('.m-ad-1'));
    this.ag_stat.addRecommendExplorePortalEleMap($('.m-ad-1-content-detail'));
    this.ag_stat.addRecommendExplorePortalEleMap($('.ad-custom'));
    this.ag_stat.addRecommendExplorePortalEleMap($('.ad-custom .btn'));
  }
}

module.exports = Advert;


// WEBPACK FOOTER //
// ./lib/js/module/m_advert/module/advert.js